import { useEffect, useState } from "react"
import { geoFetch } from "@/lib/explore/api/geo-fetch"

interface UrbanismeFeature {
  properties?: { libelle?: string; txt?: string }
}

interface UrbanismeData {
  features?: UrbanismeFeature[]
}

const urbanismeCache = new Map<string, UrbanismeData>()

export function useUrbanisme(center: [number, number] | null) {
  const [data, setData] = useState<UrbanismeData | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const lon = center?.[0] ?? null
  const lat = center?.[1] ?? null

  useEffect(() => {
    if (lon === null || lat === null) {
      setData(null)
      setLoading(false)
      setError(null)
      return
    }

    const cacheKey = `${lon},${lat}`
    const cached = urbanismeCache.get(cacheKey)
    if (cached) {
      setData(cached)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    const url = `https://www.geoportail-urbanisme.gouv.fr/api/feature-info/du?lon=${lon}&lat=${lat}&layer=parcels&format=json&typeName=info_lin,info_pct,info_surf,prescription_lin,prescription_pct,prescription_surf,secteur_cc,zone_urba`

    geoFetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`Geoportail API error: ${res.status}`)
        return res.json()
      })
      .then((json) => {
        urbanismeCache.set(cacheKey, json)
        setData(json)
        setLoading(false)
      })
      .catch((err) => {
        setError(err.message)
        setLoading(false)
      })
  }, [lon, lat])

  return { data, loading, error }
}
